import { useQuery } from 'react-query';
import { groupResponse } from 'src/models/CRM';
import { fetchGroups } from 'src/services/CRM/groups';

export default function useGroups(search?: string) {
  return useQuery<groupResponse[]>(['groups', search], () =>
    fetchGroups(search)
  );
}
